import axios from "axios";
import { __constants } from "../../constants";
const BASE_URL = process.env.REACT_APP_SERVER_URL;

/* Help&Support categories */
export const addEditSupportCategories = async (data) => {
    try {
        const config = {
            method: 'PUT',
            url: BASE_URL + "/v1/admin/support-category",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const removeSupportCategories = async (data) => {
    try {
        const config = {
            method: 'DELETE',
            url: BASE_URL + "/v1/admin/support-category",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const getSupportCategories = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/support-category",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            }
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const editAppinfo = async (data) => {
    try {
        
        const config = {
            method: 'PUT',
            url: BASE_URL + "/v1/admin/preuser-info",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}
